import { useEffect, useState } from 'react';

import { SxProps, Theme, useTheme } from '@mui/material';

import { Avatar, getContrastColor, getNameInitials, Merchant } from '@trendiolive/trendio-selfcare-ui-kit';

type MerchantAvatarProps = Readonly<{
  merchant: Merchant | null;
  size?: number;
  sx?: SxProps<Theme>;
}>;

// TODO: Refactor avatars in UI Kit ( monday - 9278869040 )
export default function MerchantAvatar({ merchant, size = 40, sx }: MerchantAvatarProps) {
  const theme = useTheme();

  const logo = merchant?.logo;

  const [initials, setInitials] = useState('');
  const [fontColor, setFontColor] = useState('#fff');

  useEffect(() => {
    if (merchant) {
      setInitials(getNameInitials(merchant.name));
      setFontColor(getContrastColor(merchant.logoBgColor ?? '#fff'));
    }
  }, [merchant]);

  return (
    <Avatar
      type="filled"
      sx={{
        width: size,
        height: size,
        objectFit: 'cover',
        backgroundColor: merchant?.logoBgColor,
        color: fontColor,
        border: '1px solid',
        borderColor: theme.palette.divider,
        ...sx
      }}
    >
      {logo && <img alt={`${merchant.name} Logo`} src={logo} width={size} height="auto" style={{ padding: size >= 40 ? 2 : 0 }} />}
      {!logo && initials}
    </Avatar>
  );
}
